/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TCWorkflowCreateBodyParams } from '../models/TCWorkflowCreateBodyParams';
import type { TCWorkflowCreateResponse } from '../models/TCWorkflowCreateResponse';
import type { TCWorkflowUpdateBodyParams } from '../models/TCWorkflowUpdateBodyParams';
import type { TCWorkflowUpdateResponse } from '../models/TCWorkflowUpdateResponse';
import type { TCWorkflowVersion } from '../models/TCWorkflowVersion';
import type { WorkflowListResponse } from '../models/WorkflowListResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AutomationsWorkflowsService {
    /**
     * List all workflows for the tenant
     * @param limit
     * @param pageToken
     * @returns WorkflowListResponse Ok
     * @throws ApiError
     */
    public static listWorkflows(
        limit?: number,
        pageToken?: string,
    ): CancelablePromise<WorkflowListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/automations/workflows',
            query: {
                'limit': limit,
                'pageToken': pageToken,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * Create a workflow
     * @param requestBody
     * @returns TCWorkflowCreateResponse Ok
     * @throws ApiError
     */
    public static createWorkflow(
        requestBody: TCWorkflowCreateBodyParams,
    ): CancelablePromise<TCWorkflowCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/automations/workflows',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * Get a specific workflow version
     * @param workflowId
     * @param version
     * @returns TCWorkflowVersion Ok
     * @throws ApiError
     */
    public static getWorkflowVersion(
        workflowId: string,
        version: string,
    ): CancelablePromise<TCWorkflowVersion> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/automations/workflows/{workflowId}/versions/{version}',
            path: {
                'workflowId': workflowId,
                'version': version,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * List versions for a workflow
     * @param workflowId
     * @returns TCWorkflowVersion Ok
     * @throws ApiError
     */
    public static listWorkflowVersions(
        workflowId: string,
    ): CancelablePromise<Array<TCWorkflowVersion>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/automations/workflows/{workflowId}/versions',
            path: {
                'workflowId': workflowId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * Update a workflow (metadata and/or draft definition)
     * @param workflowId
     * @param requestBody
     * @returns TCWorkflowUpdateResponse Ok
     * @throws ApiError
     */
    public static updateWorkflow(
        workflowId: string,
        requestBody: TCWorkflowUpdateBodyParams,
    ): CancelablePromise<TCWorkflowUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/automations/workflows/{workflowId}',
            path: {
                'workflowId': workflowId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
